import { Component, inject } from '@angular/core';
import { SectionComponent } from '../../../../components/layout/section/section.component';
import { SectionHeaderComponent } from '../../../../components/layout/section/section-header/section-header.component';
import { FilterTextsPipe } from '../../../../pipes/filterTexts/filterTexts.pipe';
import { SectionHeadlineComponent } from '../../../../components/layout/section/section-header/section-headline/section-headline.component';
import { LanguagePipe } from '../../../../pipes/language/language.pipe';
import { ButtonComponent } from '../../../../components/feedback/button/button.component';
import { UserStore } from '../../../../services/api/user/user/user-store.service';
import { QuillViewComponent } from 'ngx-quill';
import { CorporateDesignService } from '../../../../services/corporate-design/corporate-design.service';
import { EEntityType, ERelationType } from '@web/dtos';
import { WebTextStore } from '../../../../services/api/text/web-text-store.service';

@Component({
  selector: 'aw-account-delete-page',
  imports: [
    SectionComponent,
    SectionHeaderComponent,
    SectionHeadlineComponent,
    FilterTextsPipe,
    LanguagePipe,
    ButtonComponent,
    QuillViewComponent,
  ],
  templateUrl: './account-delete-page.component.html',
})
export class AccountDeletePageComponent {
  protected readonly userStore: UserStore = inject(UserStore);
  protected readonly textStore: WebTextStore = inject(WebTextStore);
  protected readonly corporateDesignService: CorporateDesignService = inject(
    CorporateDesignService
  );

  protected readonly RelationType: typeof ERelationType = ERelationType;
  protected readonly EEntityType: typeof EEntityType = EEntityType;

  protected deleteAccount(): void {
    this.userStore.deleteAccount().subscribe(() => {
      window.location.href = '/';
    });
  }
}
